export const transformServiceType = (serviceType) => {
  // Remove leading '/'
  let modifiedType = serviceType.replace(/^\//, "");
  // Replace underscores or hyphens with spaces and capitalize first letter
  modifiedType = modifiedType
    .replace(/[_-]/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
  return modifiedType;
};
